import { Action } from 'redux';
import { WeeklyBreakdownReport } from 'model/BookingsWeeklyBreakdownReport';

export const WEEKLY_BREAKDOWN_REPORT_GET_START = 'WEEKLY_BREAKDOWN_REPORT_GET_START';
export const WEEKLY_BREAKDOWN_REPORT_GET_SUCCESS = 'WEEKLY_BREAKDOWN_REPORT_GET_SUCCESS';
export const WEEKLY_BREAKDOWN_REPORT_GET_ERROR = 'WEEKLY_BREAKDOWN_REPORT_GET_ERROR';

type WeeklyBreakdownGetStartAction = Action<typeof WEEKLY_BREAKDOWN_REPORT_GET_START>;

interface WeeklyBreakdownGetSuccessAction extends Action<typeof WEEKLY_BREAKDOWN_REPORT_GET_SUCCESS> {
    payload: {
        report: WeeklyBreakdownReport;
    };
}

type WeeklyBreakdownGetErrorAction = Action<typeof WEEKLY_BREAKDOWN_REPORT_GET_ERROR>;

export type WeeklyBreakdownReportAction =
    | WeeklyBreakdownGetStartAction
    | WeeklyBreakdownGetSuccessAction
    | WeeklyBreakdownGetErrorAction;
